import { checkInputData, updateAccountDetails, resetMessages, updateEmailMarketingConsent, updateSMSMarketingConsent, getInitialCustomerData } from './utils';

if (!customElements.get('account-communication-form')) {
  class accountCommunicationForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    async init() {
      this.addEventListener('submit', this.updateCommunictionsForm);
      this.initialCustomerData = await getInitialCustomerData(window.customer.id);
      this.emailCheckbox = document.querySelector('#newsletter_email_updateAccountCommunicationForm');
      this.smsCheckbox = document.querySelector('#newsletter_sms_updateAccountCommunicationForm');
      this.toggleMarketingStatus();
      const inputs = this.querySelectorAll('input');
      inputs.forEach(input => {
        input.addEventListener('focus', resetMessages);
      });
    }

    toggleMarketingStatus() {
      if (!this.initialCustomerData) return;
      if (this.initialCustomerData.data && this.initialCustomerData.data.email_marketing_consent.state == "subscribed") {
        this.emailCheckbox.checked = true;
      }
      if (this.initialCustomerData.data && this.initialCustomerData.data.sms_marketing_consent.state == "subscribed") {
        this.smsCheckbox.checked = true;
      }
    }

    async updateCommunictionsForm(e) {
      const customer = window.customer;
      if (!customer) return;

      const emailMarketingStatus = this.emailCheckbox?.checked
      const smsMarketingStatus = this.smsCheckbox?.checked
      const form = e.srcElement;
      const submitButton = form.querySelector('button[type="submit"]');
      const formData = new FormData(form, submitButton);
      const { errors, data } = await checkInputData(formData, customer);

      if (errors && errors.length) {
        errors.forEach(error => {
          document.querySelector(`[data-form-status="${error}"]`).classList.remove('hidden');
        });
        return;
      }

      // email marketing status
      data.emailOptInLevel = this.initialCustomerData.data.email_marketing_consent.opt_in_level.toUpperCase();
      if (this.initialCustomerData && this.initialCustomerData.data.email_marketing_consent.state == "subscribed" || this.initialCustomerData.data.email_marketing_consent.state == "unsubscribed") {
        data.emailMarketingStatus = emailMarketingStatus ? "SUBSCRIBED" : "UNSUBSCRIBED";
      } else {
        data.emailMarketingStatus = emailMarketingStatus ? "SUBSCRIBED" : this.initialCustomerData.data.email_marketing_consent.state.toUpperCase();
      }
      // sms marketing status
      data.smsOptInLevel = this.initialCustomerData.data.sms_marketing_consent.opt_in_level.toUpperCase();
      if (this.initialCustomerData && this.initialCustomerData.data.sms_marketing_consent.state == "subscribed" || this.initialCustomerData.data.sms_marketing_consent.state == "unsubscribed") {
        data.smsMarketingStatus = smsMarketingStatus ? "SUBSCRIBED" : "UNSUBSCRIBED";
      } else {
        data.smsMarketingStatus = smsMarketingStatus ? "SUBSCRIBED" : this.initialCustomerData.data.sms_marketing_consent.state.toUpperCase();
      }

      if (!data || !data.id) {
        console.log('🚀 ~ error:', 'No data to update');
        document.querySelector('[data-form-status="error"]').classList.remove('hidden');
        return;
      }

      const updateRequests = [
        updateAccountDetails(data),
        updateEmailMarketingConsent(data),
        updateSMSMarketingConsent(data)
      ];

      try {
        await Promise.all(updateRequests);
        document.querySelector('[data-form-status="success"]')?.classList.remove('hidden');
        console.log('All updates succeeded');
      } catch (error) {
        console.log('🚀 ~ error:', error);
        document.querySelector('[data-form-status="error"]').classList.remove('hidden');
      }
    }

  }

  customElements.define('account-communication-form', accountCommunicationForm);
}